(() => {
  const sliders = document.querySelectorAll('[data-ew-slider]');

  sliders.forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-ew-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-ew-dot]'));
    const prev = slider.querySelector('[data-ew-prev]');
    const next = slider.querySelector('[data-ew-next]');
    if (slides.length <= 1) return;

    let index = 0;
    let timer;
    const autoplay = slider.dataset.autoplay === 'true';
    const delay = Number(slider.dataset.delay) || 5000;

    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
    };

    const start = () => {
      stop();
      if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(index + 1), delay);
      }
    };

    prev?.addEventListener('click', () => {
      show(index - 1);
      start();
    });

    next?.addEventListener('click', () => {
      show(index + 1);
      start();
    });

    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      show(i);
      start();
    }));

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    show(0);
    start();
  });

  const scrollSliders = document.querySelectorAll('[data-ew-scroll-slider]');

  scrollSliders.forEach((slider) => {
    const section = slider.closest('section');
    const slides = Array.from(slider.querySelectorAll('[data-ew-scroll-slide]'));
    const pagination = section?.querySelector('[data-ew-scroll-pagination]');
    const dots = pagination ? Array.from(pagination.querySelectorAll('[data-ew-scroll-dot]')) : [];
    if (!pagination || slides.length <= 1 || dots.length !== slides.length) return;

    let frame = 0;

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const getClosestSlide = () => {
      const sliderCenter = slider.scrollLeft + (slider.clientWidth / 2);
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
        const distance = Math.abs(slideCenter - sliderCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const sync = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => setActive(getClosestSlide()));
    };

    slider.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slide = slides[index];
        if (!slide) return;
        slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActive(index);
      });
    });

    setActive(0);
  });
})();
